import React from 'react';
import './content-mangement-popup.css'
import SaveCTA from '../component/common/savecta';
import Contentsubpagemenu from '../component/layout/content-sub-page-menu';
import Header2 from '../component/common/title';
import pic26 from '../assets/pic26.png'
import Input from '../component/common/input';
import { useState } from 'react';
import { useEffect } from 'react';
import { supabase } from '../supabase';
import Textarea from '../component/common/textarea';
import Uploadcta from '../component/common/uploadcta';
import Cta from '../component/common/cta';
import Popup from '../component/common/popup';



const Contentmangementpopups = () => {
const [search, setSearch] = useState('');

        const [popup, setPopup] = useState([]);

        useEffect(() => {
        const getPopup = async()=>{
            const res = await supabase.from('Popup_content').select('*').order('id', { ascending: true });;
        setPopup(res.data);
        };
        getPopup();
        }, []);





const updateField = (id, field, value) => {
    setPopup((prev) =>
        prev.map((item) =>
            item.id === id ? { ...item, [field]: value } : item
        )
    );
};






const [showPopup2, setShowPopup2] = useState(false);
const closePopup2 = () => {
  setShowPopup2(false);
};


const saveAll = async () => {
  for (const item of popup) {
    await supabase
      .from('Popup_content')
      .update({
        title: item.title,
        paragraph: item.paragraph,
        cta_text_primary: item.cta_text_primary,
        icon_alt: item.icon_alt,
        image: item.image,
      })
      .eq('id', item.id);
  }
    setShowPopup2(true); 

};













const [showImagePopup, setShowImagePopup] = useState(false);
const [selectedId, setSelectedId] = useState(null);
const [imageLink, setImageLink] = useState('');
    return (

 <section className='information-container'>


        <article className='header-cont-event'>
                           <Header2
                            title="Content Management"  
                            para="Manage website content and pages dynamically"
                            />
                            

                          <section className='container-table2-eventp'>
                            

                            <Contentsubpagemenu />


                            <section className='container-table-eventp'>
                                <fieldset className="input-wrapper">
                                    <input 
                                    className='input-search'
                                     placeholder="Search for popup name ..."
                                       value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                   
                                    />

                                     <img src={pic26} className="search-icon" alt="search" />
                                 </fieldset>

                                <section className='container-navigation-content'>

                                    <article className='container-part1-navigation-content'>
                                        <article className='header-container-content-change-p'>
                                            <h2 className='header-content-change-page'>Popups Content</h2>
                                            <p className='para-content-change-page'>Manage website popup content</p>
                                        </article>

                                        <section className='containerr-inputs-content-changeee-page'>
  
                                                     
        
                                             <section className='sub-container-popup-content-management'>
                                                    {showImagePopup && (
                                                    <article className="container-popup" >
                                                        <article className="cont2-popup">

                                                      

                                                        <Input
                                                        title='Paste Image Link'
                                                            type="text"
                                                            placeholder="https://..."
                                                            value={imageLink}
                                                            onChange={(e) => setImageLink(e.target.value)}
                                                        />


                                                        <nav className='container-ctas-craete'>
                                                        <Cta
                                                        title=' Save Image'
                                                            onClick={() => {
                                                            updateField(selectedId, 'image', imageLink);
                                                            setShowImagePopup(false);
                                                            setImageLink('');
                                                            }}
                                                        >
                                                            
                                                        </Cta>

                                                        <button className='cta-cancel-create' onClick={() => setShowImagePopup(false)}>
                                                            <h2 className='cta-cancel-text-create'>Cancel</h2>
                                                        </button>

                                                        </nav>






                                                        </article>
                                                    </article>
                                                    )}

                                                {popup.filter((item) =>item.popup_name?.toLowerCase().includes(search.toLowerCase()))
                                                 .map((item) => (
                                                 <section className='popup-content-main-container' key={item.id}>
                                                        <h2 className='popup-name'>{item.popup_name} </h2>
                                                        <section className='input-container-popup-content'>
                                                            <Input title='popup Title'
                                                            value={item.title || ''}
                                                            onChange={(e) =>
                                                                updateField(item.id, 'title', e.target.value)
                                                            }
                                                />


                                                            <Textarea title='Popup paragraph'
                                                            stylee='main-text-area'
                                                                        value={item.paragraph || ''}
                                                                onChange={(e) =>
                                                                    updateField(item.id, 'paragraph', e.target.value)
                                                                }
                                                            />


                                                            <section className='row-navigation-inputs'>
                                                                <Input title='CTA text primary'
                                                                           value={item.cta_text_primary || ''}
                                                                onChange={(e) =>
                                                                    updateField(item.id, 'cta_text_primary', e.target.value)
                                                                }
                                                            />

                                                                <Input title='CTA Alt'
                                                                            value={item.icon_alt || ''}
                                                                onChange={(e) =>
                                                                    updateField(item.id, 'icon_alt', e.target.value)
                                                                }
                                                            />

                                                            </section>


                                                            <fieldset className='container0img-uploadd-popup'>
                                                                <label className='title-inputt'>Popup Image</label>
                                                                    <fieldset className='main-img-upload-popup'>
                                                                    <img
                                                                        className='img-in-popups'
                                                                src={item.image || pic26}
                                                                        alt='popup'
                                                                    />

                                                                    <Uploadcta title='Upload Image'     
                                                                      onClick={() => {
                                                                                setShowImagePopup(true);
                                                                                setSelectedId(item.id);
                                                                            }}/>
                                                                    </fieldset>







                                                            </fieldset>
                                                        </section>
                                                 </section>
                                                 ))}
                                             </section>


                                        </section>

                                                    <button
                                                    className='container-save-cta'
                                                    onClick={saveAll}
                                                >
                                                    <SaveCTA title='Save Changes' />
                                                </button>



                                    </article>





                                </section>


                    {showPopup2 && (
                            <Popup
                            to="/content-management-navigations" 
                                onClose={closePopup2}
                            img={popup?.[2]?.image} 
                                alt={popup?.[2]?.icon_alt} 
                            header={popup?.[2]?.title}
                            para={popup?.[2]?.paragraph} 
                            title={popup?.[2]?.cta_text_primary} 
                            />
                    )}









                            </section>
                            
                        </section>     
                            

                                
                                  
        </article>

</section>
      );
}
 
export default Contentmangementpopups;